import { FC } from 'react';
import { Box, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ImageGalleryModalProps {
    imageUrl: string | null;
    onClose: () => void;
}

export const ImageGalleryModal: FC<ImageGalleryModalProps> = ({ imageUrl, onClose }) => {
    return (
        <Dialog
            open={!!imageUrl}
            onClose={onClose}
            maxWidth="lg"
            PaperProps={{
                sx: {
                    bgcolor: 'transparent',
                    boxShadow: 'none',
                },
            }}
        >
            <Box sx={{ position: 'relative' }}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: -40,
                        top: 0,
                        color: 'white',
                        bgcolor: 'rgba(0,0,0,0.5)',
                        '&:hover': {
                            bgcolor: 'rgba(0,0,0,0.7)',
                        },
                    }}
                >
                    <CloseIcon />
                </IconButton>
                {imageUrl && (
                    <Box
                        component="img"
                        src={imageUrl}
                        alt="Full size"
                        sx={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                        }}
                    />
                )}
            </Box>
        </Dialog>
    );
};

